export default ({
  theme, white, attach, nest, ICON, INPUT_ADORNMENT
}) => ({
  MuiInput: {
    root: {
      borderRadius: 6,
      backgroundColor: '#ffffff',
      [`& .${ICON.root}, & input::placeholder`]: {
        color: '#657786',
        opacity: 1
      },
      '&$focused': {
        backgroundColor: white.text,
        border: `1px solid ${theme.palette.primary.main}`,
        [`& input, & .${ICON.root}`]: {
          color: theme.palette.primary.main
        }
      }
    }
  },
  MuiInputAdornment: {
    positionStart: {
      [attach(INPUT_ADORNMENT.root)]: {
        [nest(ICON.root)]: {
          marginLeft: 10,
          fontSize: 20
        }
      }
    }
  }
});
